import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import mobileFunnelDescription from "../../../assets/images/funnel/funnel_description_mobile.png"
import funnelDescription from "../../../assets/images/funnel/funnel_description.png"
import mobileFunnelDescriptionEn from "../../../assets/images/funnel/funnel_description_mobile_en.png"
import funnelDescriptionEn from "../../../assets/images/funnel/funnel_description_en.png"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#fff",
      padding: "96px 0 0",
      [theme.breakpoints.up("md")]: {
        padding: "200px 0 0",
      },
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      padding: "0 20px",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function Description() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  // const { ref } = useScrollImpressionLog({
  //   message: "2. 왜 사용자 퍼널 분석을",
  //   eventKey: `homepage_funnel_section_2_impression`,
  // })
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        {lang === "ko" ? (
          <img src={isMobile ? mobileFunnelDescription : funnelDescription} />
        ) : (
          <img src={isMobile ? mobileFunnelDescriptionEn : funnelDescriptionEn} />
        )}
      </div>
    </div>
  )
}
